import api from './api';

const gastoService = {
  listar: async (filtros = {}) => {
    const { data } = await api.get('/gastos', { params: filtros });
    return data.data;
  },

  crear: async (gasto) => {
    const { data } = await api.post('/gastos', gasto);
    return data.data;
  },

  actualizar: async (id, gasto) => {
    const { data } = await api.put(`/gastos/${id}`, gasto);
    return data.data;
  },

  eliminar: async (id) => {
    await api.delete(`/gastos/${id}`);
  },
};

export default gastoService;